"use client";

import { useSite } from "@/lib/hooks/site";
import S3Image from "@/components/S3Image";
import {useEffect, useState} from "react";

interface Props {
  className?: string;
}

export default function SmallLogo(props: Props) {
  const site = useSite();

  const getSiteLogo = (usePngFile = false) => {
    if (usePngFile) return `site/${site?.id}/logo.png`;
    return `site/${site?.id}/${site.setting?.logo}`;
  };

  const [logoSrc, setLogoSrc] = useState<string>(getSiteLogo(false));

  useEffect(() => {
    setLogoSrc(getSiteLogo(false));
  }, [site]);

  return (
    <S3Image
      sizes="118px"
      className={props.className}
      width={118}
      height={29}
      src={logoSrc}
      onError={() => setLogoSrc(getSiteLogo(true))}
      alt={site.descriptions?.[0].meta_title}
      title={site.descriptions?.[0].title}
    />
  );
}
